/**
 * Action types for Network functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_SWITCH_NETWORK = 'GET_SWITCH_NETWORK';
export const GET_SWITCH_NETWORK_SUCCESS = 'GET_SWITCH_NETWORK_SUCCESS';
export const GET_SWITCH_NETWORK_FAIL = 'GET_SWITCH_NETWORK_FAIL';
export const EDIT_SWITCH_NETWORK = 'EDIT_SWITCH_NETWORK'
export const EDIT_SWITCH_NETWORK_COMPLETE =  'EDIT_SWITCH_NETWORK_COMPLETE'
export const GET_IPV4_SWITCH_NETWORK = 'GET_IPV4_SWITCH_NETWORK';
export const GET_IPV4_SWITCH_NETWORK_SUCCESS = 'GET_IPV4_SWITCH_NETWORK_SUCCESS';
export const GET_IPV4_SWITCH_NETWORK_FAIL = 'GET_IPV4_SWITCH_NETWORK_FAIL';
export const IPV4_ADD_REQUEST = 'IPV4_ADD_REQUEST';
export const IPV4_ADD_SUCCESS = 'IPV4_ADD_SUCCESS';
export const IPV4_NETWORK_ENTRY_ADDED_SUCCESSFULLY = 'IPV4_NETWORK_ENTRY_ADDED_SUCCESSFULLY';
export const IPV4_ADD_FAIL = 'IPV4_ADD_FAIL';
export const IPV4_DELETE_REQUEST = 'IPV4_DELETE_REQUEST';
export const IPV4_DELETE_SUCCESS = 'IPV4_DELETE_SUCCESS';
export const IPV4_DELETE_FAIL = 'IPV4_DELETE_FAIL';
export const EDIT_IPV4_NETWORK = 'EDIT_IPV4_NETWORK';
export const EDIT_IPV4_NETWORK_COMPLETE =  'EDIT_IPV4_NETWORK_COMPLETE';
export const EDIT_IPV4_NETWORK_FAILURE = 'EDIT_IPV4_NETWORK_FAILURE';
export const GET_IPV6_SWITCH_NETWORK = 'GET_IPV6_SWITCH_NETWORK';
export const GET_IPV6_SWITCH_NETWORK_SUCCESS = 'GET_IPV6_SWITCH_NETWORK_SUCCESS';
export const GET_IPV6_SWITCH_NETWORK_FAIL = 'GET_IPV6_SWITCH_NETWORK_FAIL';
export const IPV6_ADD_REQUEST = 'IPV6_ADD_REQUEST';
export const IPV6_NETWORK_ENTRY_ADDED_SUCCESSFULLY = 'IPV6_NETWORK_ENTRY_ADDED_SUCCESSFULLY';
export const IPV6_ADD_SUCCESS = 'IPV6_ADD_SUCCESS';
export const IPV6_ADD_FAIL = 'IPV6_ADD_FAIL';
export const IPV6_DELETE_REQUEST = 'IPV6_DELETE_REQUEST';
export const IPV6_DELETE_SUCCESS = 'IPV6_DELETE_SUCCESS';
export const IPV6_DELETE_FAIL = 'IPV6_DELETE_FAIL';
export const EDIT_IPV6_NETWORK = 'EDIT_IPV6_NETWORK';
export const EDIT_IPV6_NETWORK_COMPLETE =  'EDIT_IPV6_NETWORK_COMPLETE';
export const EDIT_IPV6_NETWORK_FAILURE = 'EDIT_IPV6_NETWORK_FAILURE';
export const RESET_IPV4_DELETE = 'RESET_IPV4_DELETE';
export const RESET_IPV4_EDIT = 'RESET_IPV4_EDIT';
export const RESET_IPV4_ADD = 'RESET_IPV4_ADD';
export const RESET_IPV6_DELETE = 'RESET_IPV6_DELETE';
export const RESET_IPV6_ADD = 'RESET_IPV6_ADD';
export const RESET_IPV6_EDIT = 'RESET_IPV6_EDIT';
export const GET_IPV6_SWITCH_MANAGEMENT = 'GET_IPV6_SWITCH_MANAGEMENT';
export const GET_IPV6_SWITCH_MANAGEMENT_SUCCESS = 'GET_IPV6_SWITCH_MANAGEMENT_SUCCESS';
export const GET_IPV6_SWITCH_MANAGEMENT_FAIL = 'GET_IPV6_SWITCH_MANAGEMENT_FAIL';
export const IPV6_MANAGEMENT_ADD_REQUEST = 'IPV6_MANAGEMENT_ADD_REQUEST';
export const IPV6_MANAGEMENT_ENTRY_ADDED_SUCCESSFULLY = 'IPV6_MANAGEMENT_ENTRY_ADDED_SUCCESSFULLY';
export const IPV6_MANAGEMENT_SUCCESS = 'IPV6_MANAGEMENT_SUCCESS';
export const IPV6_MANAGEMENT_ADD_FAIL = 'IPV6_MANAGEMENT_ADD_FAIL';
export const RESET_IPV6_MANAGEMENT_ADD = 'RESET_IPV6_MANAGEMENT_ADD';
export const EDIT_IPV6_MANAGEMENT = 'EDIT_IPV6_MANAGEMENT';
export const EDIT_IPV6_MANAGEMENT_COMPLETE =  'EDIT_IPV6_MANAGEMENT_COMPLETE';
export const EDIT_IPV6_MANAGEMENT_FAILURE = 'EDIT_IPV6_MANAGEMENT_FAILURE';
export const RESET_IPV6_MANAGEMENT_EDIT = 'RESET_IPV6_MANAGEMENT_EDIT';
export const IPV6_MANAGEMENT_DELETE_REQUEST = 'IPV6_MANAGEMENT_DELETE_REQUEST';
export const IPV6_MANAGEMENT_DELETE_SUCCESS = 'IPV6_MANAGEMENT_DELETE_SUCCESS';
export const IPV6_MANAGEMENT_DELETE_FAIL = 'IPV6_MANAGEMENT_DELETE_FAIL';
export const RESET_IPV6_MANAGEMENT_DELETE = 'RESET_IPV6_MANAGEMENT_DELETE';








 
